import { render, staticRenderFns } from "./name-headline-description.vue?vue&type=template&id=4b169c10&scoped=true"
import script from "./name-headline-description.vue?vue&type=script&lang=js"
export * from "./name-headline-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b169c10",
  null
  
)

export default component.exports